export default __webpack_public_path__ + "static/media/location_rovaniemi.a6e494a9.jpg";